
import React from 'react';
import { SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { useTranslation } from 'react-i18next';
import { ClientSubscription } from '@/models/Client';
import { useWorkoutTypes } from '@/hooks/useWorkoutTypes';

interface PaymentDialogHeaderProps {
  clientName: string;
  subscription?: ClientSubscription;
}

const PaymentDialogHeader: React.FC<PaymentDialogHeaderProps> = ({
  clientName,
  subscription,
}) => {
  const { t } = useTranslation();
  const { workoutTypes = [] } = useWorkoutTypes();

  const getWorkoutTypeName = (workoutTypeId: string) => {
    const workoutType = workoutTypes.find(wt => wt.id === workoutTypeId);
    return workoutType?.name || t('clients.unknownWorkoutType');
  };

  const dialogTitle = subscription 
    ? `${t('clients.processPaymentFor')} ${clientName} - ${getWorkoutTypeName(subscription.workoutTypeId)}`
    : `${t('clients.processPaymentFor')} ${clientName}`;

  return (
    <SheetHeader className="p-6 border-b flex-shrink-0 pt-[calc(2rem+env(safe-area-inset-top))] pwa-safe-header ios-sheet-header safe-top">
      <SheetTitle className="greek-text">
        {dialogTitle}
      </SheetTitle>
    </SheetHeader>
  );
};

export default PaymentDialogHeader;
